import { useTasksKanbanCommentsApi } from '@api/tasks-kanban/comments.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const taskId = to.params.id

  if (typeof taskId !== 'string' || !taskId) return

  void useTasksKanbanCommentsApi({ taskId })
})